<template>
  <div class="onlineExhibition">
    <div class="statusBar"></div>
    <div class="onlineContent">
      <div class="swiper">
        <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
        <van-swipe @change="onChange">
          <van-swipe-item> <img :src="detailInfo.picUrl" alt="" class="swiper_img" /> </van-swipe-item>
          <!-- <template #indicator>
          <div class="custom-indicator">{{ current + 1 }}/5</div>
        </template> -->
        </van-swipe>
      </div>
      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <div class="d-f ai-c view_total">
            <img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>{{ detailInfo.pageViewNum }}</span>
          </div>
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/date.png" alt="" class="icon" />
          <span>发布时间：{{ detailInfo.showedTime }}</span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
          <span>发布单位：{{ detailInfo.publishUnitName }}</span>
        </div>
      </div>
      <div class="detail_tabs">
        <div class="d-f ai-c">
          <div class="tab_item" :class="tabIndex == item ? 'active' : ''" v-for="(item, index) in tabs" @click="changeTab(item)">{{ item }}</div>
        </div>
        <div class="content">
          <div class="detail_msg" v-show="tabIndex == '详情介绍'" v-html="detailInfo.detail">
            <!-- {{ detailInfo.detail }} -->
          </div>

          <div class="exhibition" v-show="tabIndex == '展览展示'">
            <div class="exhibition_item" v-for="(item, index) in exhibitList" :key="index" @click="goDetail(index)">
              <div class="exhibition_img">
                <img :src="item.picUrl" alt="" />
              </div>
              <div class="title">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="collect_button">
        <div class="collect d-f ai-c jc-c">
          <div class="d-f ai-c" @click="handleFavorite">
            <img src="@/assets/images/detail/performance/collect.png" alt="" v-if="!detailInfo.isFavorite" />
            <img src="@/assets/images/detail/culturalCollection/collect.png" alt="" v-else />
            <span>收藏</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getExhibitDetails, getExhibit } from '@/api/exhibition'
import { submitUserFavorite, cancelFavorite } from '@/api/operation'
import { getToken, getVenueToken } from '@/utils/auth'

export default {
  name: 'onlineExhibition',
  data() {
    return {
      current: 0,
      tabs: [],
      tabIndex: '详情介绍',
      detailInfo: {},
      params: {
        exhibitId: '',
        page: 1,
        size: 10,
      },
      exhibitList: [],
      total: 0,
      state: true,
    }
  },
  methods: {
    back() {
      this.$myUni.postMessage({
        data: {
          methodsName: 'UNIBack',
        },
      })
      // this.$myUni.navigateBack({
      //   delta: 1,
      // })
    },
    onChange(index) {
      this.current = index
    },
    changeTab(item) {
      if (item !== this.tabIndex) {
        this.tabIndex = item
        if (this.tabIndex == '展览展示') {
          this.exhibitList = []
          this.params.page = 1
          this.params.size = 10
          this.getExhibits()
        }
      }
    },
    goDetail(index) {
      console.log(index)
      this.$router.push({
        path: '/detail/exhibitionDetail',
        query: {
          id: this.params.exhibitId,
          index: index,
        },
      })
    },
    getExhibits() {
      console.log(this.params)
      getExhibit(this.params).then((res) => {
        this.total = res.result.total
        this.exhibitList = [...this.exhibitList, ...res.result.records]
      })
    },
    getDetail() {
      getExhibitDetails(this.params.exhibitId).then((res) => {
        this.detailInfo = res.result
        // this.tabs = ['详情介绍', '展览展示']
        if (this.detailInfo.detail) {
          this.tabs = ['详情介绍', '展览展示']
        } else {
          this.tabs = ['展览展示']
          this.tabIndex = '展览展示'
          this.exhibitList = []
          this.params.page = 1
          this.params.size = 10
          this.getExhibits()
        }
        console.log(this.detailInfo.detail, '1111')
      })
    },
    handleFavorite() {
      if (!getToken()) {
        this.$myUni.postMessage({
          data: {
            methodsName: 'UNIPage',

            data: {
              id: this.params.exhibitId,
              url: '/detail/onlineExhibition',
              needLocation: false,
            },
          },
        })
        // this.$myUni.navigateTo({
        //   url: '/pages/login/index',
        // })
        return
      }
      if (!this.detailInfo.isFavorite) {
        submitUserFavorite({ type: 3, basicId: this.params.exhibitId }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.isFavorite = !this.detailInfo.isFavorite
          }
        })
      } else {
        // 取消收藏
        cancelFavorite({ type: 3, basicId: this.params.exhibitId }).then((res) => {
          if (res.code == 2000) {
            // this.getDetail()
            this.detailInfo.isFavorite = !this.detailInfo.isFavorite
          }
        })
      }
    },
  },
  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.params.exhibitId = data.id
    this.getDetail()
  },
}
</script>
<style lang="scss">
.onlineExhibition {
  width: 100%;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #fff;
  }
  .onlineContent {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 40px);
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 40px;
    left: 0;
    overflow-y: auto;
  }

  .collect_button {
    padding-top: 0.6rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 2.4rem;
    .collect {
      font-size: 0.7rem;
      font-weight: 400;
      color: #212121;
      img {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 8px;
      }
    }
  }
  .swiper {
    width: 100%;
    height: 10.55rem;
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      // top: 0.5rem;
      // top: calc(8px + env(safe-area-inset-top));
      top: 8px;
    }

    .swiper_img {
      width: 100%;
      height: 10.55rem;
    }
    .custom-indicator {
      position: absolute;
      height: 0.95rem;
      line-height: 0.95rem;
      right: 8px;
      bottom: 8px;
      padding: 0 9px;
      font-size: 0.6rem;
      background: rgba(0, 0, 0, 0.5);
      color: #fff;
      border-radius: 0.5rem;
    }
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
      margin-top: 0.8rem;
    }
    .view_total {
      font-size: 0.5rem;
      // color: #47988a;
      color: #a97048;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      // background: #dff2f2;
      background: #f9eddc;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .detail_tabs {
    padding: 0.75rem 0.6rem 0 0.6rem;
    padding-bottom: calc(2.5rem + env(safe-area-inset-bottom));

    .tab_item {
      position: relative;
      font-size: 0.8rem;
      color: #999999;
      line-height: 1.2rem;
      margin-right: 0.8rem;
      &.active {
        font-weight: 600;
        color: #212121;
        &::before {
          content: '';
          display: inline-block;
          width: 1.6rem;
          height: 2px;
          // background: #47988a;
          background: #a97048;
          border-radius: 2px;
          position: absolute;
          left: calc(50% - 0.8rem);
          bottom: -4px;
        }
      }
    }
    .content {
      margin-top: 0.9rem;
      .detail_msg {
        font-size: 0.7rem;
        color: #666666;
        line-height: 1rem;
      }
      .exhibition {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .exhibition_item {
          width: calc(50% - 0.5rem);
          .exhibition_img {
            position: relative;
            width: 100%;
            height: 0;
            padding-bottom: 100%;
            // height: 8.45rem;
            border-radius: 0.5rem;
          }
          img {
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            position: absolute;
            border-radius: 0.5rem;
          }
          .title {
            font-size: 0.7rem;
            font-weight: 600;
            color: #212121;
            line-height: 1rem;
            margin: 0.4rem 0 0.6rem 0;
          }
        }
      }
    }
  }
}
</style>
